import HACCPModule from "./HACCPModule";
import AdminCalendar from './AdminCalendar';
import StockModule from "./StockModule";
import FoodCost from './FoodCost';
import React, { useState, useEffect } from 'react';
import SparrowChat from './SparrowChat';
import LangSwitcher from './LangSwitcher';
import { useTranslation } from 'react-i18next';
var MenuSelection = require('./MenuSelection');

var API = 'https://surabaya-api.onrender.com/api';;
var HORAIRES_MIDI = ["11:30","11:45","12:00","12:15","12:30","12:45","13:00","13:15","13:30","13:45"];
var HORAIRES_SOIR = ["19:00","19:15","19:30","19:45","20:00","20:15","20:30","20:45","21:00","21:15","21:30"];
// Flag sécheresse + horaires de départ calèche : voir src/config.js
var CONFIG = require('./config');
var SECHERESSE = CONFIG.SECHERESSE;
var DEPARTS_ACTIFS = CONFIG.DEPARTS_ACTIFS;
var TARIFS = {
  balade:{a:19,e:12.5,fam2:51,fam3:58,grp:18},
  calecheBateau:{a:23.5,e:17.5,fam2:65,fam3:76,grp:22.5},
  journee:{a:58.5,e:39},
  journeeLight:{a:49}
};

// Jours de fermeture hebdomadaire : voir src/config.js (estJourFerme).
// La regle y est definie UNE fois, et le serveur applique la meme
// (surabaya-backend/services/horaires.js) — le formulaire et l'API ne
// peuvent plus diverger comme avant.
function getSaison(dateStr) {
  if (!dateStr) return null;
  if (CONFIG.estJourFerme(dateStr)) return "ferme";
  // Midi local : voir le commentaire dans config.js
  var d = new Date(String(dateStr).slice(0, 10) + 'T12:00:00');
  var m = d.getMonth() + 1;
  if (m >= 4 && m <= 10) {
    if (m >= 7 && m <= 8) return "haute";
    return "reservation";
  }
  return "ferme";   // calèches : pas de circulation de novembre à mars
}

function getRestoSaison(dateStr) {
  if (!dateStr) return null;
  return CONFIG.estJourFerme(dateStr) ? "ferme" : "ouvert";
}

function Badge(props) {
  var s = props.s;
  var m = {confirmee:{bg:"#dcfce7",c:"#166534",l:"Confirmee"},attente:{bg:"#fef3c7",c:"#92400e",l:"En attente"},annulee:{bg:"#fee2e2",c:"#991b1b",l:"Annulee"}}[s]||{bg:"#e2e8f0",c:"#475569",l:s};
  return React.createElement('span',{style:{background:m.bg,color:m.c,padding:"3px 10px",borderRadius:20,fontSize:12,fontWeight:600,whiteSpace:"nowrap"}},m.l);
}

// ==========================================
// Helper pour les requêtes admin authentifiées
// ==========================================
function authFetch(url, token, options) {
  var opts = options || {};
  var headers = Object.assign({}, opts.headers || {}, {
    'Authorization': 'Bearer ' + token,
    'Content-Type': 'application/json'
  });
  return fetch(url, Object.assign({}, opts, { headers: headers }));
}

// ==========================================
// Page de Login Admin
// ==========================================
function LoginPage(props) {
  var onLogin = props.onLogin;
  var _pwd = useState(''); var pwd = _pwd[0]; var sPwd = _pwd[1];
  var _err = useState(''); var err = _err[0]; var sErr = _err[1];
  var _loading = useState(false); var loading = _loading[0]; var sL = _loading[1];

  function submit() {
    sL(true);
    sErr('');
    fetch(API + '/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password: pwd })
    })
    .then(function(r) { return r.json() })
    .then(function(data) {
      sL(false);
      if (data.success) {
        onLogin(data.token);
      } else {
        sErr('Mot de passe incorrect');
        sPwd('');
      }
    })
    .catch(function() {
      sL(false);
      sErr('Erreur de connexion au serveur');
    });
  }

  function onKeyDown(e) {
    if (e.key === 'Enter' && pwd) submit();
  }

  return React.createElement('div', {style: {minHeight: '100vh', background: 'linear-gradient(165deg, #1a0f07 0%, #2d1a0e 30%, #3d2415 60%, #1a0f07 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20}},
    React.createElement('div', {style: {background: 'rgba(255,255,255,0.95)', borderRadius: 20, padding: '36px 28px', maxWidth: 380, width: '100%', textAlign: 'center'}},
      React.createElement('div', {style: {fontSize: 48, marginBottom: 12}}, '\uD83D\uDD10'),
      React.createElement('h2', {style: {margin: '0 0 6px', fontSize: 20, color: '#2d1a0e'}}, 'Admin Surabaya'),
      React.createElement('p', {style: {margin: '0 0 24px', fontSize: 13, color: '#94a3b8'}}, 'Entrez le mot de passe pour accéder à la gestion'),

      err && React.createElement('div', {style: {background: '#fee2e2', border: '1px solid #fecaca', borderRadius: 10, padding: '8px 12px', marginBottom: 14, fontSize: 13, color: '#991b1b'}}, '\u274C ' + err),

      React.createElement('input', {
        type: 'password',
        value: pwd,
        onChange: function(e) { sPwd(e.target.value) },
        onKeyDown: onKeyDown,
        placeholder: 'Mot de passe',
        style: {width: '100%', padding: 14, border: '1px solid #d1d5db', borderRadius: 12, fontSize: 16, boxSizing: 'border-box', marginBottom: 14, textAlign: 'center'}
      }),

      React.createElement('button', {
        onClick: submit,
        disabled: !pwd || loading,
        style: {width: '100%', padding: 14, borderRadius: 12, border: 'none', fontSize: 15, fontWeight: 700, cursor: pwd && !loading ? 'pointer' : 'default', background: pwd && !loading ? 'linear-gradient(135deg, #2d1a0e, #4a2c17)' : '#d1d5db', color: pwd && !loading ? '#e8c47c' : '#9ca3af'}
      }, loading ? '\u23F3 Connexion...' : '\uD83D\uDD13 Se connecter')
    )
  );
}

function ClientPage(props) {
  var onAdd = props.onAdd;
  var _t = useTranslation(); var t = _t.t;
  var _step = useState("choix"); var step = _step[0]; var ss = _step[1];
  var _menuSel = useState(null); var menuSelections = _menuSel[0]; var setMenuSel = _menuSel[1];
  var _type = useState(""); var type = _type[0]; var st = _type[1];
  var _form = useState(""); var formule = _form[0]; var sfo = _form[1];
  var _f = useState({date:"",heure:"",nb:2,nom:"",tel:"",email:"",comm:"",ad:2,enf:0,forfait:""}); var f = _f[0]; var sf = _f[1];
  var _done = useState(null); var done = _done[0]; var sd = _done[1];
  var _loading = useState(false); var loading = _loading[0]; var sL = _loading[1];
  var _closures = useState([]); var clientClosures = _closures[0]; var sClientClosures = _closures[1];
  var _dispo = useState(null); var dispoInfo = _dispo[0]; var sDispo = _dispo[1];
  var _apiOk = useState(true); var apiOk = _apiOk[0]; var sApiOk = _apiOk[1];
  useEffect(function(){
    var params = new URLSearchParams(window.location.search);
    if (params.get('paiement') === 'ok') {
      var resaId = params.get('resa_id');
      var sessionId = params.get('session_id');
      fetch(API + '/stripe/verify?session_id=' + sessionId)
        .then(function(r){ return r.json(); })
        .then(function(stripe){
          sd({id: resaId, statut: 'confirmee', paiement: true, prix: stripe.amount / 100, email: stripe.email});
          ss('done');
        })
        .catch(function(){
          sd({id: resaId, statut: 'confirmee', paiement: true});
          ss('done');
        });
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);
  useEffect(function(){ fetch(API+'/health',{method:'GET'}).then(function(r){if(!r.ok)throw new Error();sApiOk(true)}).catch(function(){sApiOk(false)}); },[]);
  useEffect(function(){ fetch(API+'/closures/public').then(function(r){return r.json()}).then(sClientClosures).catch(function(){}); },[]);
  useEffect(function(){ if(type==="restaurant"&&f.date){ fetch(API+'/reservations/disponibilite?date='+f.date).then(function(r){return r.json()}).then(function(d){if(d&&d.date)sDispo(d)}).catch(function(){}); } else { sDispo(null); } },[type,f.date,f.heure]);

  function u(e){sf(Object.assign({},f,{[e.target.name]:e.target.value}))}
  function isAuto(){return type!=="fondue"&&f.nb<=6}

  function prix(){
    if(type==="restaurant")return null;
    if(type==="fondue"){
      var n=Number(f.nb);
      if(n<=9)return 420;if(n<=14)return 470;return 490;
    }
    var t=TARIFS[formule];
    if(!t)return 0;
    if(f.forfait==="fam2" && t.fam2) return t.fam2;
    if(f.forfait==="fam3" && t.fam3) return t.fam3;
    var total = Number(f.ad)+Number(f.enf);
    if(total>=12 && t.grp) return total * t.grp;
    return Number(f.ad)*t.a + Number(f.enf)*(t.e||0);
  }


function go(menuData) {
    if (step !== "menu") { if (!canSubmit) return; if (type === "restaurant") { ss("menu"); return; } }
    sL(true);
    var p = prix();
    var prixNum = typeof p === "string" ? 0 : (p || 0);
    var body = {
      type: type,
      formule: formule || null,
      forfait: f.forfait || null,
      date: f.date,
      heure: f.heure,
      nb_personnes: Number(f.nb),
      nb_adultes: type==="caleche" ? Number(f.ad) : 0,
      nb_enfants: type==="caleche" ? Number(f.enf) : 0,
      nom: f.nom,
      telephone: f.tel,
      email: f.email,
      commentaires: f.comm + (menuData && menuData.items && menuData.items.length > 0 ? "\n--- PRE-COMMANDE ---\n" + menuData.items.map(function(i){ return i.quantity + "x " + i.name; }).join("\n") + "\nTotal: " + menuData.total.toFixed(2) + " EUR" : ""),
      statut: (type === "caleche" || type === "fondue") ? "attente" : (isAuto() ? "confirmee" : "attente"),
      canal: window.location.search.indexOf("admin") !== -1 ? "admin" : "web",
      prix: prixNum
    };

    fetch(API + '/reservations', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    })
    .then(function(res){ if(res.status===409 || res.status===423){ res.json().then(function(d){ sL(false); alert("⛔ "+d.message); }); throw new Error("bloque"); } return res.json(); })
    .then(function(data){
      sL(false);
      if ((data.type === 'caleche' || data.type === 'fondue') && data.id) {
        fetch(API + '/stripe/create-checkout', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({reservation_id: data.id})
        })
        .then(function(r){ return r.json(); })
        .then(function(stripe){
          if (stripe.url) { window.location.href = stripe.url; }
          else { sL(false); alert("⚠️ Erreur paiement : " + (stripe.error || "Impossible de créer la session de paiement.")); }
        })
        .catch(function(e){ sL(false); alert("⚠️ Erreur paiement. Verifiez votre email et reessayez."); console.error(e); });
      } else {
        sd(data);
        ss("done");
      }
      if(onAdd) onAdd(data);
    })
    .catch(function(err){
      sL(false);
     if(err.message !== "complet" && err.message !== "bloque") alert("Erreur de connexion au serveur. Reessayez.");
      console.error(err);
    });
  }

  var td=new Date().toISOString().split("T")[0];
  var saison = (type==="caleche"||type==="fondue"||type==="bateau"||type==="caleche_bateau"||type==="journee_complete") ? getSaison(f.date) : null;
  var restoOk = type==="restaurant" ? getRestoSaison(f.date) : null;
  // Fermé parce que c'est un lundi/mardi/mercredi, ou fermé parce qu'on est
  // hors saison calèche ? Le message affiché n'est pas le même.
  var jourFerme = CONFIG.estJourFerme(f.date);
  // Même mapping que le backend (routes/closures.js getClosure) : cuisine et calèche
  var usesCuisine = ["restaurant","journee_complete","journee","caleche_fondue","fondue"].indexOf(type) !== -1;
  var usesCaleche = ["caleche","caleche_bateau","bateau","journee_complete","journee","caleche_fondue","fondue"].indexOf(type) !== -1;
  var dateFermee = Array.isArray(clientClosures) && clientClosures.some(function(c){ var cd = c.date.split('T')[0]; var pResa = f.heure < '15:00' ? 'midi' : 'soir'; var svcMatch = c.service === 'all' || (c.service === 'restaurant' && usesCuisine) || (c.service === 'caleche' && usesCaleche); return cd === f.date && svcMatch && !c.heure && (c.periode === 'journee' || c.periode === pResa); });
  // Créneaux de départ fermés individuellement (fermeture par heure côté admin)
  var heuresFermees = Array.isArray(clientClosures) ? clientClosures.filter(function(c){ var svcMatch = c.service === 'all' || (c.service === 'restaurant' && usesCuisine) || (c.service === 'caleche' && usesCaleche); return c.heure && f.date && c.date.split('T')[0] === f.date && svcMatch; }).map(function(c){ return c.heure.substring(0,5); }) : [];
  var canSubmit = f.date && f.heure && f.nom && f.tel && f.email && (saison !== "ferme") && (restoOk !== "ferme") && !loading && !dateFermee && heuresFermees.indexOf(f.heure) === -1 && !(dispoInfo && ((f.heure && f.heure < '15:00' && dispoInfo.complet_midi) || (f.heure && f.heure >= '15:00' && dispoInfo.complet_soir)));
var msgFerme = dateFermee ? "⛔ Ce service est fermé à cette date" : null;
  var inp={width:"100%",padding:"12px",border:"1px solid rgba(0,0,0,0.15)",borderRadius:10,fontSize:16,boxSizing:"border-box",background:"white",color:"#1a1a1a"};
  var lab={fontWeight:600,fontSize:14,display:"block",marginBottom:4,color:"#2d1a0e"};

  return (
    React.createElement('div',{style:{minHeight:"100vh",background:"linear-gradient(165deg, #1a0f07 0%, #2d1a0e 30%, #3d2415 60%, #1a0f07 100%)",padding:"20px 16px"}},
      React.createElement('div',{style:{maxWidth:540,margin:"0 auto"}},

        React.createElement('div',{style:{textAlign:"center",marginBottom:28,color:"white"}},
          React.createElement('h1',{style:{fontSize:26,margin:0,fontWeight:800,color:"#e8c47c",letterSpacing:1}},t("site.titre")),
          React.createElement('p',{style:{fontSize:13,opacity:.7,margin:"6px 0 0",color:"#c4a882"}},t("site.soustitre")),
          React.createElement('p',{style:{fontSize:11,opacity:.5,margin:"2px 0 0",color:"#c4a882"}},t("site.contact")),
          React.createElement('div',{style:{marginTop:10}},React.createElement(LangSwitcher,null))
        ),

        SECHERESSE && React.createElement('div',{style:{background:"rgba(217,119,6,.14)",border:"1px solid rgba(251,191,36,.55)",borderRadius:14,padding:"14px 16px",marginBottom:18,color:"#fcd34d"}},
          React.createElement('div',{style:{fontSize:14,fontWeight:800,marginBottom:6}},t("secheresse.titre")),
          React.createElement('div',{style:{fontSize:13,lineHeight:1.55,color:"#fde8c0"}},t("secheresse.desc"))
        ),

        CONFIG.estPeriodeHiver() && React.createElement('div',{style:{background:"rgba(59,130,246,.12)",border:"1px solid rgba(147,197,253,.5)",borderRadius:14,padding:"14px 16px",marginBottom:18,color:"#bfdbfe"}},
          React.createElement('div',{style:{fontSize:14,fontWeight:800,marginBottom:6}},t("hiver.titre")),
          React.createElement('div',{style:{fontSize:13,lineHeight:1.55,color:"#dbeafe"}},t("hiver.desc"))
        ),

        !apiOk && React.createElement('div',{style:{background:"rgba(255,255,255,.95)",borderRadius:16,padding:"30px 20px",color:"#1a1a2e",textAlign:"center"}},
          React.createElement('div',{style:{fontSize:40,marginBottom:12}},"🔧"),
          React.createElement('h2',{style:{fontSize:18,color:"#2d1a0e",margin:"0 0 10px"}},t("maintenance.titre")),
          React.createElement('p',{style:{fontSize:14,color:"#6b7280",margin:"0 0 16px"}},t("maintenance.desc")),
          React.createElement('a',{href:"tel:+33768359787",style:{display:"inline-block",background:"linear-gradient(135deg,#8B6914,#e8c47c)",color:"#2d1a0e",padding:"12px 24px",borderRadius:10,fontSize:16,fontWeight:700,textDecoration:"none"}},"📞 07 68 35 97 87")
        ),

        apiOk && step==="choix" && React.createElement('div',null,
          React.createElement('a',{href:'https://surabayacafe.fr',style:{display:'block',textAlign:'left',color:'#c8a96e',fontSize:14,textDecoration:'none',marginBottom:8,paddingLeft:4}},"\u2190 Retour au site"),
          React.createElement('h2',{style:{color:"#e8c47c",textAlign:"center",fontSize:17,marginBottom:16}},t("choix.titre")),

          React.createElement('div',{onClick:function(){st("restaurant");ss("form")},style:{background:"rgba(232,196,124,0.08)",border:"1px solid rgba(232,196,124,0.2)",borderRadius:14,padding:16,cursor:"pointer",color:"white",marginBottom:10}},
            React.createElement('div',{style:{fontSize:26}},"\uD83C\uDF7D\uFE0F"),
            React.createElement('div',{style:{fontSize:16,fontWeight:700,marginTop:4,color:"#e8c47c"}},t("choix.restaurant.titre")),
            React.createElement('div',{style:{fontSize:13,opacity:.6,marginTop:2}},t("choix.restaurant.desc")),
            React.createElement('div',{style:{fontSize:11,opacity:.4,marginTop:4}},t("choix.restaurant.horaires"))
          ),

          React.createElement('div',{onClick:function(){st("caleche");ss("formule")},style:{background:"rgba(232,196,124,0.08)",border:"1px solid rgba(232,196,124,0.2)",borderRadius:14,padding:16,cursor:"pointer",color:"white",marginBottom:10}},
            React.createElement('div',{style:{fontSize:26}},"\uD83D\uDC34"),
            React.createElement('div',{style:{fontSize:16,fontWeight:700,marginTop:4,color:"#e8c47c"}},t("choix.caleche.titre")),
            React.createElement('div',{style:{fontSize:13,opacity:.6,marginTop:2}},t("choix.caleche.desc")),
            React.createElement('div',{style:{fontSize:11,opacity:.4,marginTop:4}},t("choix.caleche.saison"))
          ),

          React.createElement('div',{onClick:function(){st("fondue");ss("form")},style:{background:"rgba(232,196,124,0.08)",border:"1px solid rgba(232,196,124,0.2)",borderRadius:14,padding:16,cursor:"pointer",color:"white",marginBottom:10}},
            React.createElement('div',{style:{fontSize:26}},"\uD83E\uDDC0"),
            React.createElement('div',{style:{fontSize:16,fontWeight:700,marginTop:4,color:"#e8c47c"}},t("choix.fondue.titre")),
            React.createElement('div',{style:{fontSize:13,opacity:.6,marginTop:2}},t("choix.fondue.desc")),
            React.createElement('div',{style:{fontSize:11,opacity:.4,marginTop:4}},t("choix.fondue.saison"))
          )
        ),

        step==="formule" && React.createElement('div',null,
          React.createElement('div',{onClick:function(){ss("choix")},style:{color:"rgba(232,196,124,.5)",cursor:"pointer",marginBottom:10,fontSize:14}},"\u2190 Retour"),
          React.createElement('h2',{style:{color:"#e8c47c",textAlign:"center",fontSize:17,marginBottom:14}},t("formule.titre")),

          React.createElement('div',{onClick:function(){if(SECHERESSE)return;sfo("journee");sf(Object.assign({},f,{forfait:""}));ss("form")},style:{background:SECHERESSE?"rgba(232,196,124,0.05)":"rgba(232,196,124,0.15)",border:SECHERESSE?"1px solid rgba(232,196,124,0.15)":"2px solid rgba(232,196,124,0.4)",borderRadius:14,padding:"16px",cursor:SECHERESSE?"default":"pointer",color:"white",marginBottom:10,position:"relative",opacity:SECHERESSE?.55:1}},
            React.createElement('div',{style:{position:"absolute",top:-10,right:12,background:SECHERESSE?"#ef4444":"#e8c47c",color:SECHERESSE?"white":"#2d1a0e",padding:"2px 10px",borderRadius:10,fontSize:11,fontWeight:800}},SECHERESSE?t("secheresse.badge"):t("formule.journee.badge")),
            React.createElement('div',{style:{fontSize:15,fontWeight:700,color:"#e8c47c"}},"\u2600\uFE0F Journee complete Franco-Suisse"),
            React.createElement('div',{style:{fontSize:12,opacity:.7,marginTop:4}},t("formule.journee.desc")),
            SECHERESSE ?
              React.createElement('div',{style:{fontSize:12,marginTop:6,color:"#fca5a5",fontWeight:600}},t("secheresse.suspendu")) :
              React.createElement('div',{style:{fontSize:13,marginTop:6,color:"#e8c47c"}},t("formule.journee.tarif"))
          ),

          React.createElement('div',{onClick:function(){if(SECHERESSE)return;sfo("calecheBateau");sf(Object.assign({},f,{forfait:""}));ss("form")},style:{background:SECHERESSE?"rgba(232,196,124,0.05)":"rgba(232,196,124,0.08)",border:"1px solid rgba(232,196,124,0.2)",borderRadius:12,padding:"14px 16px",cursor:SECHERESSE?"default":"pointer",color:"white",marginBottom:8,opacity:SECHERESSE?.55:1}},
            React.createElement('div',{style:{fontSize:15,fontWeight:700}},"\uD83D\uDC34 + \u26F5 Caleche + Bateau (2h30)"),
            React.createElement('div',{style:{fontSize:12,opacity:.6,marginTop:2}},t("formule.calechebateau.desc")),
            SECHERESSE ?
              React.createElement('div',{style:{fontSize:12,marginTop:4,color:"#fca5a5",fontWeight:600}},t("secheresse.suspendu")) :
              React.createElement('div',{style:{fontSize:12,color:"#e8c47c",marginTop:4}},t("formule.calechebateau.tarif"))
          ),

          React.createElement('div',{onClick:function(){sfo("balade");sf(Object.assign({},f,{forfait:""}));ss("form")},style:{background:"rgba(232,196,124,0.08)",border:"1px solid rgba(232,196,124,0.2)",borderRadius:12,padding:"14px 16px",cursor:"pointer",color:"white",marginBottom:8}},
            React.createElement('div',{style:{fontSize:15,fontWeight:700}},"\uD83D\uDC34 Balade en caleche (1h30)"),
            React.createElement('div',{style:{fontSize:12,opacity:.6,marginTop:2}},t("formule.balade.desc")),
            React.createElement('div',{style:{fontSize:12,color:"#e8c47c",marginTop:4}},"19\u20AC/ad. \u2022 12.50\u20AC/enf. \u2022 Famille 2+2: 51\u20AC \u2022 2+3: 58\u20AC \u2022 Grp 12+: -1\u20AC/p. \u2022 -2 ans gratuit")
          )
        ),

        step==="form" && React.createElement('div',null,
          React.createElement('div',{onClick:function(){ss(type==="caleche"?"formule":"choix");sf(Object.assign({},f,{date:"",heure:"",forfait:""}))},style:{color:"rgba(232,196,124,.5)",cursor:"pointer",marginBottom:10,fontSize:14}},"\u2190 Retour"),
          React.createElement('div',{style:{background:"rgba(255,255,255,.95)",borderRadius:16,padding:"22px 18px",color:"#1a1a2e"}},
            React.createElement('h2',{style:{fontSize:17,marginTop:0,marginBottom:16,color:"#2d1a0e"}},
              type==="restaurant"?"\uD83C\uDF7D\uFE0F Reservation Restaurant":type==="fondue"?"\uD83E\uDDC0 Caleche Fondue (privative)":"\uD83D\uDC34 "+({balade:"Balade en caleche (1h30)",calecheBateau:"Caleche + Bateau (2h30)",journee:"Journee Franco-Suisse"}[formule]||"")
            ),

            React.createElement('label',{style:{display:"block",marginBottom:12}},
              React.createElement('span',{style:lab},t("form.date")),
              React.createElement('input',{type:"date",name:"date",min:td,value:f.date,onChange:u,style:inp})
            ),

            (saison==="ferme"||restoOk==="ferme") && React.createElement('div',{style:{background:"#fee2e2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#991b1b"}},
              jourFerme ? t("alert.ferme.jour") : t("alert.ferme.caleche")
            ),

            saison==="reservation" && React.createElement('div',{style:{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#1e40af"}},
              "\u2139\uFE0F En cette periode, les departs sont sur reservation. Nous confirmerons votre creneau."
            ),

            saison==="haute" && React.createElement('div',{style:{background:SECHERESSE?"#fffbeb":"#f0fdf4",border:SECHERESSE?"1px solid #fde68a":"1px solid #bbf7d0",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:SECHERESSE?"#92400e":"#166534"}},
              SECHERESSE ? t("secheresse.horaires") : "\u2705 Juillet-Aout : 3 departs garantis chaque jour !"
            ),

            restoOk==="ferme" && React.createElement('div',{style:{background:"#fee2e2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#991b1b"}},
              "\u274C Le restaurant est ferme ce jour (ouvert du jeudi au dimanche, oct-mai)."
            ),

            dispoInfo && ((f.heure && f.heure < '15:00' && dispoInfo.complet_midi) || (f.heure && f.heure >= '15:00' && dispoInfo.complet_soir)) && React.createElement('div',{style:{background:"#fef3c7",border:"1px solid #fde68a",borderRadius:10,padding:"14px",marginBottom:12,fontSize:13,color:"#92400e",textAlign:"center"}},
              "\u26A0\uFE0F Les reservations en ligne pour ce service sont completes. Des places peuvent rester disponibles sur place (passage ou bar). N'hesitez pas a passer directement !"
            ),

            (type==="caleche"||type==="fondue") && React.createElement('div',{style:{background:"#fff3cd",border:"1px solid #ffc107",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:12,color:"#856404",fontWeight:500}},"⚠️ Paiement en ligne requis au moment de la réservation. Toute réservation non payée dans les 30 minutes sera automatiquement annulée. En cas de problème, contactez-nous au 07 68 35 97 87."),saison!=="ferme" && restoOk!=="ferme" && React.createElement('label',{style:{display:"block",marginBottom:12}},
              React.createElement('span',{style:lab},t("form.horaire")),
              React.createElement('select',{name:"heure",value:f.heure,onChange:u,style:Object.assign({},inp,{background:"white"})},
                React.createElement('option',{value:""},t("form.horaire.choisir")),
                type==="restaurant" ?
                  [React.createElement('optgroup',{label:t("form.horaire.midi"),key:"midi"},HORAIRES_MIDI.map(function(h){return React.createElement('option',{key:h,value:h},h)})),
                   React.createElement('optgroup',{label:t("form.horaire.soir"),key:"soir"},HORAIRES_SOIR.map(function(h){return React.createElement('option',{key:h,value:h},h)}))]
                : (formule==="journee"?["11:30"]:DEPARTS_ACTIFS).filter(function(h){return heuresFermees.indexOf(h)===-1}).map(function(h){return React.createElement('option',{key:h,value:h},h)})
              )
            ),

            type==="fondue" && React.createElement('label',{style:{display:"block",marginBottom:12}},
              React.createElement('span',{style:lab},t("form.personnes.fondue")),
              React.createElement('input',{type:"number",name:"nb",min:6,max:16,value:f.nb,onChange:u,style:inp})
            ),

            type==="restaurant" && React.createElement('div',{style:{marginBottom:12}},
              React.createElement('span',{style:lab},t("form.personnes")),
              React.createElement('input',{type:"number",name:"nb",min:1,max:120,value:f.nb,onChange:u,style:inp}),
              f.nb>=12 && React.createElement('div',{style:{fontSize:12,color:"#d97706",marginTop:3}},"\u26A0\uFE0F Groupe 12+ : menu unique obligatoire. Nous vous contacterons pour le choix du menu."),
              f.nb>=7 && f.nb<12 && React.createElement('div',{style:{fontSize:12,color:"#2563eb",marginTop:3}},"\u2139\uFE0F Validation requise (confirmation sous 24h)")
            ),

            type==="caleche" && React.createElement('div',null,
              React.createElement('div',{style:{display:"flex",gap:10,marginBottom:12}},
                React.createElement('label',{style:{flex:1}},
                  React.createElement('span',{style:lab},t("form.adultes")),
                  React.createElement('input',{type:"number",name:"ad",min:1,max:30,value:f.ad,onChange:function(e){sf(Object.assign({},f,{ad:e.target.value,nb:Number(e.target.value)+Number(f.enf),forfait:""}))},style:inp})
                ),
                React.createElement('label',{style:{flex:1}},
                  React.createElement('span',{style:lab},t("form.enfants")),
                  React.createElement('input',{type:"number",name:"enf",min:0,max:20,value:f.enf,onChange:function(e){sf(Object.assign({},f,{enf:e.target.value,nb:Number(f.ad)+Number(e.target.value),forfait:""}))},style:inp})
                )
              ),

              (formule==="balade"||formule==="calecheBateau") && Number(f.ad)===2 && (Number(f.enf)===2||Number(f.enf)===3) && React.createElement('div',{style:{background:"#fef3c7",border:"1px solid #fde68a",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#92400e"}},
                React.createElement('strong',null,"\uD83C\uDF89 Forfait famille disponible ! "),
                React.createElement('div',{style:{marginTop:6,display:"flex",gap:8}},
                  React.createElement('button',{onClick:function(){sf(Object.assign({},f,{forfait:Number(f.enf)===2?"fam2":"fam3"}))},
                    style:{padding:"6px 14px",borderRadius:8,border:f.forfait?"2px solid #059669":"1px solid #d1d5db",background:f.forfait?"#dcfce7":"white",cursor:"pointer",fontSize:12,fontWeight:600}},
                    "\u2705 Forfait "+(Number(f.enf)===2?"2+2":"2+3")+" : "+(Number(f.enf)===2?(TARIFS[formule].fam2):TARIFS[formule].fam3)+"\u20AC"
                  ),
                  f.forfait && React.createElement('button',{onClick:function(){sf(Object.assign({},f,{forfait:""}))},
                    style:{padding:"6px 14px",borderRadius:8,border:"1px solid #d1d5db",background:"white",cursor:"pointer",fontSize:12}},
                    "Tarif individuel"
                  )
                )
              ),

              Number(f.ad)+Number(f.enf)>=12 && !f.forfait && (formule==="balade"||formule==="calecheBateau") && React.createElement('div',{style:{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#1e40af"}},
                "\uD83D\uDC65 Tarif groupe applique : -1\u20AC/pers. soit "+TARIFS[formule].grp+"\u20AC/pers."
              )
            ),

            type!=="restaurant" && saison!=="ferme" && React.createElement('div',{style:{background:"#fefce8",border:"1px solid #fde68a",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:14,color:"#713f12"}},
              React.createElement('strong',null,t("form.estimation")),
              prix()+" \u20AC",
              type==="fondue" && React.createElement('span',{style:{fontSize:12,opacity:.6}}," (boissons facturees au retour)"),
              f.forfait && React.createElement('span',{style:{fontSize:12,color:"#059669",fontWeight:600}}," \u2022 Forfait famille applique !")
            ),

            React.createElement('hr',{style:{border:"none",borderTop:"1px solid #e5e7eb",margin:"14px 0"}}),
            React.createElement('label',{style:{display:"block",marginBottom:12}},React.createElement('span',{style:lab},t("form.nom")),React.createElement('input',{name:"nom",autoComplete:"name",value:f.nom,onChange:u,placeholder:t("form.nom.placeholder"),style:inp})),
            React.createElement('label',{style:{display:"block",marginBottom:12}},React.createElement('span',{style:lab},t("form.tel")),React.createElement('input',{name:"tel",type:"tel",autoComplete:"tel",value:f.tel,onChange:u,placeholder:t("form.tel.placeholder"),style:inp})),
            React.createElement('label',{style:{display:"block",marginBottom:12}},React.createElement('span',{style:lab},t("form.email")),React.createElement('input',{name:"email",type:"email",autoComplete:"email",value:f.email,onChange:u,placeholder:t("form.email.placeholder"),style:inp})),
            React.createElement('label',{style:{display:"block",marginBottom:16}},React.createElement('span',{style:lab},t("form.commentaires")),React.createElement('textarea',{name:"comm",value:f.comm,onChange:u,rows:3,placeholder:t("form.commentaires.placeholder"),style:Object.assign({},inp,{resize:"vertical"})})),


            React.createElement('button',{onClick:go,disabled:!canSubmit,
              style:{width:"100%",padding:14,borderRadius:12,border:"none",fontSize:15,fontWeight:700,cursor:canSubmit?"pointer":"default",background:canSubmit?"linear-gradient(135deg,#8B6914,#e8c47c)":"#d1d5db",color:canSubmit?"#2d1a0e":"#9ca3af"}},
              loading?"\u23F3 Envoi en cours...":saison==="ferme"||restoOk==="ferme"?"\u26D4 Indisponible a cette date":isAuto()?"\u2705 Reserver maintenant":"\uD83D\uDCE9 Envoyer la demande"
            )
          )
        ),

        step==="menu" && type==="restaurant" && React.createElement("div", {style:{borderRadius:16,padding:"22px 18px"}},
          React.createElement("div", {onClick:function(){ss("form")},style:{color:"rgba(232,196,124,.5)",cursor:"pointer",marginBottom:10,fontSize:14}}, "\u2190 Retour"),
          React.createElement(MenuSelection, {
            nbPersonnes: Number(f.nb),
            onValidate: function(data) { go(data); },
            onSkip: function() { go(null); }
          })
        ),

        step==="done" && done && React.createElement('div',{style:{borderRadius:16,padding:"22px 18px",textAlign:"center"}},
          React.createElement('div',{style:{fontSize:52,marginBottom:8}},done.statut==="confirmee"?"\u2705":"\uD83D\uDCE9"),
          React.createElement('h2',{style:{color:done.statut==="confirmee"?"#059669":"#d97706",margin:"0 0 6px",fontSize:20}},done.statut==="confirmee"?t("done.confirmee.titre"):t("done.attente.titre")),
          React.createElement('p',{style:{color:"#6b7280",fontSize:13}},done.statut==="confirmee"?t("done.confirmee.desc"):t("done.attente.desc")),
          React.createElement('div',{style:{textAlign:"left",background:"#faf5eb",borderRadius:10,padding:12,margin:"14px 0",fontSize:14,lineHeight:1.8}},
            React.createElement('div',null,React.createElement('strong',null,"Ref : "),"#"+done.id),
            React.createElement('div',null,React.createElement('strong',null,"Date : "),done.date ? done.date.split("T")[0] : ""," a ",done.heure ? done.heure.substring(0,5) : ""),
            React.createElement('div',null,React.createElement('strong',null,"Personnes : "),done.nb_personnes),
            done.prix>0 && React.createElement('div',null,React.createElement('strong',null,"Estimation : "),done.prix," \u20AC")
          ),
          React.createElement('button',{onClick:function(){ss("choix");st("");sfo("");sf({date:"",heure:"",nb:2,nom:"",tel:"",email:"",comm:"",ad:2,enf:0,forfait:""});sd(null)},style:{padding:"10px 24px",borderRadius:10,border:"none",background:"#2d1a0e",color:"#e8c47c",cursor:"pointer",fontSize:14,fontWeight:600}},t("done.nouvelle"))
        )
      )
    )
  );
}

function AdminPage(props) {
  var token = props.token;
  var onLogout = props.onLogout;
  var _resas = useState([]); var resas = _resas[0]; var sR = _resas[1];
  var _stats = useState({en_attente:0,couverts_aujourdhui:0,cette_semaine:0,total:0}); var stats = _stats[0]; var sS = _stats[1];
  var _fil = useState("all"); var fil = _fil[0]; var sF = _fil[1];
  var _loading = useState(true); var loading = _loading[0]; var sL = _loading[1];
var _settings = useState({}); var settings = _settings[0]; var sSettings = _settings[1];
   var _closures = useState([]); var closures = _closures[0]; var sClosures = _closures[1];
  var _newDate = useState(''); var newDate = _newDate[0]; var sNewDate = _newDate[1];
  var _newService = useState('restaurant'); var newService = _newService[0]; var sNewService = _newService[1];
  var _newPeriode = useState('journee'); var newPeriode = _newPeriode[0]; var sNewPeriode = _newPeriode[1];
function load(){
    sL(true);
    Promise.all([
      authFetch(API+'/reservations', token).then(function(r){
        if (r.status === 401) { onLogout(); return []; }
        return r.json();
      }),
      authFetch(API+'/reservations/stats', token).then(function(r){
        if (r.status === 401) { onLogout(); return {}; }
        return r.json();
      }),
      authFetch(API+'/closures', token).then(function(r){
        return r.json();
}).catch(function(){ return []; }),
      authFetch(API+'/settings', token).then(function(r){
        return r.json();
      }).catch(function(){ return {}; })
    ]).then(function(results){
      sR(results[0] || []);
      sS(results[1] || {en_attente:0,couverts_aujourdhui:0,cette_semaine:0,total:0});
      sSettings(results[3] || {});
      sClosures(results[2] || []);
      sL(false);
    }).catch(function(err){
      console.error(err);
      sL(false);
    });
  }

  useEffect(function(){ load() }, []);

  function changeStatut(id, statut){
    authFetch(API+'/reservations/'+id+'/statut', token, {
      method:'PATCH',
      body: JSON.stringify({statut:statut})
    }).then(function(){ load() });
  }

  function changeArrival(id, arrived){
    sR(function(prev){ return prev.map(function(x){ return x.id===id ? Object.assign({}, x, {arrived: arrived}) : x; }); });
    authFetch(API+'/reservations/'+id+'/arrival', token, {
      method:'PATCH',
      body: JSON.stringify({arrived: arrived})
    }).catch(function(){
      sR(function(prev){ return prev.map(function(x){ return x.id===id ? Object.assign({}, x, {arrived: !arrived}) : x; }); });
    });
  }

  function doLogout() {
    authFetch(API+'/logout', token, { method: 'POST' }).catch(function(){});
    onLogout();
  }
function toggleBlock(key) {
    var newVal = settings[key] === 'true' ? 'false' : 'true';
    authFetch(API+'/settings', token, {
      method:'POST',
      body: JSON.stringify({key: key, value: newVal})
    }).then(function(){ load(); });
  }
  function addClosure() {
    if (!newDate) return;
    authFetch(API+'/closures', token, {
      method:'POST',
    body: JSON.stringify({service: newService, date: newDate, periode: newPeriode})
    }).then(function(){ sNewDate(''); load(); });
  }

  function delClosure(id) {
    authFetch(API+'/closures/'+id, token, {
      method:'DELETE'
    }).then(function(){ load(); });
  }
  var today = new Date().toISOString().split("T")[0]; var fl = resas.filter(function(r){ var rd = r.date ? r.date.split("T")[0] : ""; if(fil==="att")return r.statut==="attente"; if(fil==="ok")return r.statut==="confirmee" && rd >= today; if(fil==="no")return r.statut==="annulee"; if(fil==="past")return rd < today && r.statut!=="annulee"; return rd >= today || r.statut==="attente"; });

  return (
    React.createElement('div',{style:{minHeight:"100vh",background:"#f5f0e8"}},
      React.createElement('div',{style:{background:"linear-gradient(135deg,#2d1a0e,#4a2c17)",color:"white",padding:"16px 18px"}},
        React.createElement('div',{style:{maxWidth:800,margin:"0 auto"}},
          React.createElement('div',{style:{display:"flex",justifyContent:"space-between",alignItems:"center"}},
            React.createElement('h1',{style:{margin:0,fontSize:18,fontWeight:800,color:"#e8c47c"}},"\uD83C\uDF9B\uFE0F Admin Surabaya"),
            React.createElement('div',{style:{display:"flex",gap:8}},
              React.createElement('button',{onClick:load,style:{background:"rgba(255,255,255,.15)",border:"none",color:"#e8c47c",padding:"6px 12px",borderRadius:8,cursor:"pointer",fontSize:12}},"\uD83D\uDD04 Rafraichir"),
              React.createElement('button',{onClick:doLogout,style:{background:"rgba(239,68,68,.3)",border:"none",color:"#fca5a5",padding:"6px 12px",borderRadius:8,cursor:"pointer",fontSize:12}},"\uD83D\uDEAA Déconnexion")
            )
          ),
          React.createElement('div',{style:{display:"flex",gap:8,marginTop:12,flexWrap:"wrap"}},
            [{l:"En attente",v:stats.en_attente,c:"#fbbf24"},{l:"Couverts auj.",v:stats.couverts_aujourdhui,c:"#60a5fa"},{l:"Cette semaine",v:stats.cette_semaine,c:"#34d399"},{l:"Total",v:stats.total,c:"#a78bfa"}].map(function(s,i){
              return React.createElement('div',{key:i,style:{background:"rgba(255,255,255,.1)",borderRadius:10,padding:"8px 14px",flex:"1 1 80px"}},
                React.createElement('div',{style:{fontSize:10,opacity:.7}},s.l),
                React.createElement('div',{style:{fontSize:24,fontWeight:800,color:s.c}},s.v)
              )
            })
          )
        )
      ,React.createElement('div',{style:{display:"flex",gap:8,marginTop:12,flexWrap:"wrap"}},
            [{k:"block_restaurant",l:"🍽️ Restaurant",c:"#ef4444"},{k:"block_caleche",l:"🐴 Calèche",c:"#f59e0b"},{k:"block_all",l:"🔒 Tout bloquer",c:"#dc2626"}].map(function(b){
              var isOn = settings[b.k] === 'true';
              return React.createElement('button',{key:b.k,onClick:function(){toggleBlock(b.k)},style:{padding:"8px 14px",borderRadius:10,border:"none",cursor:"pointer",fontSize:12,fontWeight:700,background:isOn?"rgba(239,68,68,.3)":"rgba(255,255,255,.1)",color:isOn?"#fca5a5":"#86efac",transition:"all .2s"}},
                (isOn ? "⛔ " : "✅ ") + b.l + (isOn ? " FERMÉ" : " OUVERT")
              )
            })
          )),
      React.createElement('div',{style:{maxWidth:800,margin:"0 auto",padding:"14px 12px"}},
        React.createElement('div',{style:{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}},
          [{k:"all",l:"Toutes"},{k:"att",l:"En attente ("+stats.en_attente+")"},{k:"ok",l:"Confirmees"},{k:"no",l:"Annulees"},{k:"past",l:"Passees"}].map(function(x){
            return React.createElement('button',{key:x.k,onClick:function(){sF(x.k)},style:{padding:"6px 12px",borderRadius:20,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:fil===x.k?"#2d1a0e":"white",color:fil===x.k?"#e8c47c":"#475569"}},x.l)
          })
        ),
React.createElement('div',{style:{background:"white",borderRadius:12,padding:16,marginBottom:14,boxShadow:"0 1px 2px rgba(0,0,0,.05)"}},
          React.createElement('h3',{style:{margin:"0 0 12px",fontSize:14,color:"#2d1a0e"}},"📅 Dates de fermeture"),
          React.createElement('div',{style:{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}},
            React.createElement('select',{value:newService,onChange:function(e){sNewService(e.target.value)},style:{padding:"8px 12px",borderRadius:8,border:"1px solid #e0dcd7",fontSize:13}},
              React.createElement('option',{value:"restaurant"},"🍽️ Restaurant"),
              React.createElement('option',{value:"caleche"},"🐴 Calèche"),
              React.createElement('option',{value:"all"},"🔒 Tout")
            ),
            React.createElement('select',{value:newPeriode,onChange:function(e){sNewPeriode(e.target.value)},style:{padding:"8px 12px",borderRadius:8,border:"1px solid #e0dcd7",fontSize:13}},
              React.createElement('option',{value:"journee"},"📅 Journée entière"),
              React.createElement('option',{value:"midi"},"☀️ Midi"),
              React.createElement('option',{value:"soir"},"🌙 Soir")
            ),
            React.createElement('input',{type:"date",value:newDate,onChange:function(e){sNewDate(e.target.value)},style:{padding:"8px 12px",borderRadius:8,border:"1px solid #e0dcd7",fontSize:13}}),
            React.createElement('button',{onClick:addClosure,style:{padding:"8px 14px",borderRadius:8,border:"none",background:"#ef4444",color:"white",cursor:"pointer",fontSize:13,fontWeight:700}},"⛔ Fermer ce jour")
          ),
          closures.length > 0 && React.createElement('div',{style:{display:"flex",gap:6,flexWrap:"wrap"}},
            closures.map(function(c){
              var d = new Date(c.date);
              var label = (c.service==="restaurant"?"🍽️":c.service==="caleche"?"🐴":"🔒") + " " + d.toLocaleDateString('fr-FR',{weekday:'short',day:'numeric',month:'short'}) + (c.periode==="midi"?" ☀️midi":c.periode==="soir"?" 🌙soir":"");
              return React.createElement('div',{key:c.id,style:{display:"flex",alignItems:"center",gap:4,background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"4px 8px",fontSize:12}},
                React.createElement('span',null,label),
                React.createElement('button',{onClick:function(){delClosure(c.id)},style:{background:"none",border:"none",cursor:"pointer",fontSize:14,color:"#ef4444"}},"✕")
              )
            })
          )
        ),
        loading && React.createElement('div',{style:{textAlign:"center",padding:32,color:"#94a3b8",fontSize:14}},"\u23F3 Chargement..."),

        !loading && fl.length===0 && React.createElement('div',{style:{textAlign:"center",padding:32,color:"#94a3b8",fontSize:14}},"Aucune reservation"),

        !loading && fl.map(function(r){
          var dateStr = r.date ? r.date.split('T')[0] : '';
          var heureStr = r.heure ? r.heure.substring(0,5) : '';
          return React.createElement('div',{key:r.id,style:{background:"white",borderRadius:12,padding:"12px 16px",marginBottom:8,boxShadow:"0 1px 2px rgba(0,0,0,.05)",borderLeft:r.statut==="attente"?"4px solid #f59e0b":r.statut==="confirmee"?"4px solid #10b981":"4px solid #ef4444"}},
            React.createElement('div',{style:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}},
              React.createElement('div',{style:{flex:1,minWidth:0}},
                React.createElement('div',{style:{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}},
                  React.createElement('span',{style:{fontWeight:700,fontSize:14}},(r.type==="restaurant"?"\uD83C\uDF7D\uFE0F":r.type==="fondue"?"\uD83E\uDDC0":"\uD83D\uDC34")+" "+r.nom),
                  React.createElement(Badge,{s:r.statut}),
                  React.createElement('span',{style:{fontSize:11,background:"#f5f0e8",padding:"2px 6px",borderRadius:6}},({web:"\uD83C\uDF10",clara:"\uD83E\uDD16",telephone:"\uD83D\uDCDE",email:"\uD83D\uDCE7",thefork:"\uD83C\uDF74"}[r.canal]||"")+" "+r.canal),
                  React.createElement('span',{style:{fontSize:10,color:"#cbd5e1"}},"#"+r.id)
                ),
                React.createElement('div',{style:{display:"flex",gap:12,marginTop:5,fontSize:13,color:"#64748b",flexWrap:"wrap"}},
                  React.createElement('span',null,"\uD83D\uDCC5 "+dateStr),
                  React.createElement('span',null,"\uD83D\uDD50 "+heureStr),
                  React.createElement('span',null,"\uD83D\uDC65 "+r.nb_personnes+"p."),
                  r.nb_personnes>=12 && React.createElement('span',{style:{color:"#d97706",fontWeight:600}},"GROUPE"),
                  r.forfait && React.createElement('span',{style:{color:"#059669",fontSize:11}},"FORFAIT FAMILLE"),
                  r.prix>0 && React.createElement('span',{style:{color:"#8B6914",fontSize:11}},r.prix+"\u20AC")
                ),
                r.commentaires && React.createElement('div',{style:{marginTop:8,padding:"8px 10px",background:"#fef3c7",borderLeft:"3px solid #f59e0b",borderRadius:6,fontSize:13,color:"#78350f",fontWeight:500,whiteSpace:"pre-wrap"}},"\uD83D\uDCAC "+r.commentaires),
                React.createElement('div',{style:{marginTop:3,fontSize:11,color:"#cbd5e1"}},r.telephone+(r.email?" | "+r.email:""))
              ),
              (r.statut==="attente" || r.statut==="confirmee") && React.createElement('div',{style:{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}},
                r.statut==="confirmee" && React.createElement('label',{style:{display:"flex",alignItems:"center",gap:6,padding:"8px 12px",borderRadius:8,background:r.arrived?"#059669":"#f1f5f9",color:r.arrived?"white":"#475569",cursor:"pointer",fontWeight:700,fontSize:13,userSelect:"none",transition:"all .15s"}},
                  React.createElement('input',{type:"checkbox",checked:!!r.arrived,onChange:function(e){changeArrival(r.id,e.target.checked)},style:{width:18,height:18,cursor:"pointer",margin:0}}),
                  r.arrived ? "\u2705 Arrive" : "Arrive ?"
                ),
                r.statut==="attente" && React.createElement('button',{onClick:function(){changeStatut(r.id,"confirmee")},style:{padding:"8px 16px",borderRadius:8,border:"none",background:"#059669",color:"white",cursor:"pointer",fontWeight:700,fontSize:13}},"\u2705 Valider"),
                React.createElement('button',{onClick:function(){changeStatut(r.id,"annulee")},style:{padding:"8px 16px",borderRadius:8,border:"none",background:"#ef4444",color:"white",cursor:"pointer",fontWeight:700,fontSize:13}},"\u274C")
              )
            )
          )
        })
      )
    )
  );
}
function MaReservation(props) {
  var resaToken = props.token;
  var _resa = useState(null); var resa = _resa[0]; var sResa = _resa[1];
  var _loading = useState(true); var loading = _loading[0]; var sL = _loading[1];
  var _edit = useState(false); var edit = _edit[0]; var sEdit = _edit[1];
  var _form = useState({}); var form = _form[0]; var sForm = _form[1];
  var _msg = useState(null); var msg = _msg[0]; var sMsg = _msg[1];
  var _confirm = useState(false); var confirmAnnul = _confirm[0]; var sConfirm = _confirm[1];

  useEffect(function() {
    fetch(API + '/reservations/token/' + resaToken)
      .then(function(r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function(data) { sResa(data); sForm({date: data.date.split('T')[0], heure: data.heure.substring(0,5), nb_personnes: data.nb_personnes, commentaires: data.commentaires || ''}); sL(false); })
      .catch(function() { sL(false); });
  }, []);

  function save() {
    sL(true);
    fetch(API + '/reservations/token/' + resaToken, {
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(form)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) { sResa(data); sEdit(false); sMsg('ok'); sL(false); setTimeout(function(){sMsg(null)}, 3000); })
    .catch(function() { sMsg('err'); sL(false); });
  }

  function annuler() {
    sL(true);
    fetch(API + '/reservations/token/' + resaToken + '/annuler', {
      method: 'PATCH',
      headers: {'Content-Type': 'application/json'}
    })
    .then(function(r) { return r.json(); })
    .then(function(data) { sResa(data.reservation); sConfirm(false); sMsg('annulee'); sL(false); })
    .catch(function() { sMsg('err'); sL(false); });
  }

  var inp = {width:"100%",padding:"12px",border:"1px solid rgba(0,0,0,0.15)",borderRadius:10,fontSize:16,boxSizing:"border-box",background:"white",color:"#1a1a1a"};
  var lab = {fontWeight:600,fontSize:14,display:"block",marginBottom:4,color:"#2d1a0e"};

  return React.createElement('div',{style:{minHeight:"100vh",background:"linear-gradient(165deg, #1a0f07 0%, #2d1a0e 30%, #3d2415 60%, #1a0f07 100%)",padding:"20px 16px"}},
    React.createElement('div',{style:{maxWidth:540,margin:"0 auto"}},
      React.createElement('div',{style:{textAlign:"center",marginBottom:28,color:"white"}},
        React.createElement('h1',{style:{fontSize:26,margin:0,fontWeight:800,color:"#e8c47c",letterSpacing:1}},"Surabaya Cafe"),
        React.createElement('p',{style:{fontSize:13,opacity:.7,margin:"6px 0 0",color:"#c4a882"}},"Gestion de votre reservation")
      ),

      loading && !resa && React.createElement('div',{style:{textAlign:"center",padding:40,color:"#e8c47c"}},"\u23F3 Chargement..."),

      !loading && !resa && React.createElement('div',{style:{background:"rgba(255,255,255,.95)",borderRadius:16,padding:"30px 20px",textAlign:"center"}},
        React.createElement('div',{style:{fontSize:48,marginBottom:12}},"\u274C"),
        React.createElement('h2',{style:{fontSize:18,color:"#991b1b",margin:"0 0 10px"}},"Reservation introuvable"),
        React.createElement('p',{style:{fontSize:14,color:"#6b7280"}},"Ce lien n'est plus valide ou la reservation n'existe pas.")
      ),

      resa && React.createElement('div',{style:{background:"rgba(255,255,255,.95)",borderRadius:16,padding:"22px 18px"}},

        msg==='ok' && React.createElement('div',{style:{background:"#dcfce7",border:"1px solid #bbf7d0",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#166534"}},"\u2705 Modification enregistree !"),
        msg==='annulee' && React.createElement('div',{style:{background:"#fee2e2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#991b1b"}},"\u274C Reservation annulee. Un email de confirmation vous a ete envoye."),
        msg==='err' && React.createElement('div',{style:{background:"#fee2e2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:"#991b1b"}},"\u26A0\uFE0F Une erreur est survenue. Reessayez ou contactez-nous."),

        React.createElement('div',{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}},
          React.createElement('h2',{style:{fontSize:17,margin:0,color:"#2d1a0e"}},(resa.type==="restaurant"?"\uD83C\uDF7D\uFE0F":resa.type==="fondue"?"\uD83E\uDDC0":"\uD83D\uDC34")+" Reservation #"+resa.id),
          React.createElement(Badge,{s:resa.statut})
        ),

        !edit && React.createElement('div',{style:{lineHeight:2,fontSize:14}},
          React.createElement('div',null,React.createElement('strong',null,"Nom : "),resa.nom),
          React.createElement('div',null,React.createElement('strong',null,"Date : "),resa.date?resa.date.split('T')[0]:''),
          React.createElement('div',null,React.createElement('strong',null,"Heure : "),resa.heure?resa.heure.substring(0,5):''),
          React.createElement('div',null,React.createElement('strong',null,"Personnes : "),resa.nb_personnes),
          resa.commentaires && React.createElement('div',null,React.createElement('strong',null,"Commentaires : "),resa.commentaires),
          resa.prix > 0 && React.createElement('div',null,React.createElement('strong',null,"Prix : "),resa.prix+" \u20AC")
        ),

        edit && resa.statut !== 'annulee' && React.createElement('div',null,
          React.createElement('label',{style:{display:"block",marginBottom:12}},React.createElement('span',{style:lab},"Date"),React.createElement('input',{type:"date",value:form.date,onChange:function(e){sForm(Object.assign({},form,{date:e.target.value}))},style:inp})),
          React.createElement('label',{style:{display:"block",marginBottom:12}},React.createElement('span',{style:lab},"Heure"),
            React.createElement('select',{value:form.heure,onChange:function(e){sForm(Object.assign({},form,{heure:e.target.value}))},style:inp},
              React.createElement('option',{value:""},"Choisir"),
              resa.type==="restaurant" ?
                [React.createElement('optgroup',{label:"Midi",key:"midi"},HORAIRES_MIDI.map(function(h){return React.createElement('option',{key:h,value:h},h)})),
                 React.createElement('optgroup',{label:"Soir",key:"soir"},HORAIRES_SOIR.map(function(h){return React.createElement('option',{key:h,value:h},h)}))]
              : DEPARTS_ACTIFS.map(function(h){return React.createElement('option',{key:h,value:h},h)})
            )
          ),
          React.createElement('label',{style:{display:"block",marginBottom:12}},React.createElement('span',{style:lab},"Personnes"),React.createElement('input',{type:"number",min:1,max:120,value:form.nb_personnes,onChange:function(e){sForm(Object.assign({},form,{nb_personnes:parseInt(e.target.value)}))},style:inp})),
          React.createElement('label',{style:{display:"block",marginBottom:16}},React.createElement('span',{style:lab},"Commentaires"),React.createElement('textarea',{value:form.commentaires,onChange:function(e){sForm(Object.assign({},form,{commentaires:e.target.value}))},rows:3,style:Object.assign({},inp,{resize:"vertical"})})),

          React.createElement('div',{style:{display:"flex",gap:8}},
            React.createElement('button',{onClick:save,disabled:loading,style:{flex:1,padding:12,borderRadius:10,border:"none",background:"linear-gradient(135deg,#8B6914,#e8c47c)",color:"#2d1a0e",fontWeight:700,fontSize:14,cursor:"pointer"}},loading?"\u23F3":"Enregistrer"),
            React.createElement('button',{onClick:function(){sEdit(false)},style:{padding:12,borderRadius:10,border:"1px solid #d1d5db",background:"white",cursor:"pointer",fontSize:14}},"Annuler")
          )
        ),

        React.createElement('hr',{style:{border:"none",borderTop:"1px solid #e5e7eb",margin:"16px 0"}}),

        resa.statut !== 'annulee' && !edit && React.createElement('div',{style:{display:"flex",gap:8}},
          React.createElement('button',{onClick:function(){sEdit(true)},style:{flex:1,padding:12,borderRadius:10,border:"none",background:"#2d1a0e",color:"#e8c47c",fontWeight:700,fontSize:14,cursor:"pointer"}},"\u270F\uFE0F Modifier"),
          React.createElement('button',{onClick:function(){sConfirm(true)},style:{padding:12,borderRadius:10,border:"1px solid #ef4444",background:"white",color:"#ef4444",fontWeight:700,fontSize:14,cursor:"pointer"}},"\u274C Annuler la reservation")
        ),

        confirmAnnul && React.createElement('div',{style:{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:16,marginTop:12,textAlign:"center"}},
          React.createElement('p',{style:{margin:"0 0 12px",fontSize:14,color:"#991b1b",fontWeight:600}},"Etes-vous sur de vouloir annuler cette reservation ?"),
          React.createElement('div',{style:{display:"flex",gap:8,justifyContent:"center"}},
            React.createElement('button',{onClick:annuler,disabled:loading,style:{padding:"10px 20px",borderRadius:8,border:"none",background:"#ef4444",color:"white",fontWeight:700,cursor:"pointer"}},loading?"\u23F3":"Oui, annuler"),
            React.createElement('button',{onClick:function(){sConfirm(false)},style:{padding:"10px 20px",borderRadius:8,border:"1px solid #d1d5db",background:"white",cursor:"pointer"}},"Non, garder")
          )
        )
      )
    )
  );
}
function App() {
  var _p = useState("client"); var p = _p[0]; var sP = _p[1];
  var _badge = useState(0); var badge = _badge[0]; var sB = _badge[1];
  var _token = useState(localStorage.getItem('surabaya_token') || ''); var token = _token[0]; var sToken = _token[1];

  function handleLogin(t) {
    localStorage.setItem('surabaya_token', t);
    sToken(t);
  }

  function handleLogout() {
    localStorage.removeItem('surabaya_token');
    sToken('');
    sP('client');
  }
  var isAdmin = window.location.search.indexOf('admin') !== -1;
  // Vérifier si le token est encore valide, au chargement ET au retour sur
  // l'onglet. Les sessions admin vivent en mémoire côté serveur (auth.js) :
  // un redéploiement Render les efface pendant que l'onglet reste ouvert.
  // Sans cette re-vérification, on ne s'en apercevait qu'en essayant
  // d'enregistrer — et le message affiché était un « Erreur serveur »
  // trompeur, alors que la saisie était simplement perdue.
  useEffect(function() {
    if (!token) return undefined;
    var verifier = function() {
      fetch(API + '/check-auth', {
        headers: { 'Authorization': 'Bearer ' + token }
      }).then(function(r) {
        if (r.status === 401) handleLogout();
      }).catch(function() {});
    };
    verifier();
    var auRetour = function() { if (!document.hidden) verifier(); };
    window.addEventListener('focus', auRetour);
    document.addEventListener('visibilitychange', auRetour);
    return function() {
      window.removeEventListener('focus', auRetour);
      document.removeEventListener('visibilitychange', auRetour);
    };
  }, [token]);

var urlParams = new URLSearchParams(window.location.search);
  var resaToken = urlParams.get('token');
  if (resaToken) {
    return React.createElement(MaReservation, {token: resaToken});
  }
  var isFoodCost = window.location.search.indexOf('foodcost') !== -1;
  var isHaccp = window.location.search.indexOf("haccp") !== -1;
  if (isHaccp) { return React.createElement(HACCPModule, null); }
  if (isFoodCost) { return React.createElement(FoodCost, null); }
  var isEquipe = ['patrick','christian','coralie','mamat','cocher'].some(k => window.location.search.indexOf(k) !== -1);
  if (isEquipe) { return React.createElement(require('./EquipePage').default, null); }
  var isStaff = window.location.search.indexOf('staff') !== -1;
  if (isStaff) { return React.createElement(require('./StaffAssistant').default, null); }
  var isDashboard = window.location.search.indexOf('dashboard') !== -1;
  if (isDashboard) { return React.createElement(require('./Dashboard').default, null); }
  var isStock = window.location.search.indexOf('stock') !== -1;
  if (isStock) { return React.createElement(StockModule, null); }
  return React.createElement('div',null,
    isAdmin && React.createElement('div',{style:{position:"fixed",top:0,left:0,right:0,zIndex:999,background:"#1a0f07",display:"flex",justifyContent:"center",borderBottom:"1px solid rgba(232,196,124,.2)"}},
      React.createElement('button',{onClick:function(){sP("client")},style:{flex:1,padding:10,border:"none",cursor:"pointer",fontWeight:700,fontSize:14,background:p==="client"?"#4a2c17":"transparent",color:"#e8c47c",maxWidth:180}},"\uD83C\uDF10 Client"),
      React.createElement('button',{onClick:function(){sP("admin")},style:{flex:1,padding:10,border:"none",cursor:"pointer",fontWeight:700,fontSize:14,background:p==="admin"?"#4a2c17":"transparent",color:"#e8c47c",maxWidth:180,position:"relative"}},
        (token ? "\uD83D\uDD13" : "\uD83D\uDD10") + " Admin",
        badge>0 && React.createElement('span',{style:{position:"absolute",top:4,marginLeft:4,background:"#ef4444",color:"white",borderRadius:"50%",width:18,height:18,fontSize:11,display:"inline-flex",alignItems:"center",justifyContent:"center",fontWeight:800}},badge)
      )
    ),
    React.createElement('div',{style:{paddingTop:isAdmin?40:0}},
      p==="client" && React.createElement(ClientPage,{onAdd:function(){
        if (token) {
          authFetch(API+'/reservations/stats', token).then(function(r){return r.json()}).then(function(d){sB(d.en_attente)}).catch(function(){});
        }
      }}),
isAdmin && p==="admin" && !token && React.createElement(LoginPage, {onLogin: function(t){sToken(t); sP("admin")}}),
      isAdmin && p==="admin" && token && React.createElement(AdminCalendar, {token: token, onLogout: handleLogout}),
    )
  );
  <SparrowChat />
}

export default App;
